import {isCellLocked} from "./lock_cell";
import group from "./undo_group";


var ignoreUndoReset = false;

export function init(view){
	reset(view);
	undoHandlers(view);
	view.attachEvent("onHardReset", () => reset(view));
	view.attachEvent("onAfterSheetShow", () => reset(view));
	// styles
	view.attachEvent("onStyleChange", (row, column, nstyle, ostyle, page) =>{
		if(page == view.getActiveSheet())
			addToHistory(view, {action: "style", row:row, column: column, value: ostyle, newValue: nstyle, group: group.value});
	});
	// editing
	view.attachEvent("onBeforeValueChange", (row, column, nvalue, ovalue, page) => {
		if (isCellLocked(view, row, column, page)) return false;
		if(page == view.getActiveSheet()){
			const source = view._mPage.getCell(row-1, column-1, true).source;
			addToHistory(view, {action: "value", row:row, column: column, value: source ? "" : ovalue, newValue: nvalue, group: group.value});
		}
	});
	// merge cells
	view.attachEvent("onAfterSpan", (row, column, value) => {
		addToHistory(view, {action: "span", row:row, column: column, value: value, newValue:value, group: group.value});
	});
	// split cells
	view.attachEvent("onBeforeSplit", (row, column, value) => {
		if (isCellLocked(view, row, column)) return false;
		addToHistory(view, {action: "split", row:row, column: column, value: value, newValue:value, group: group.value});
	});
	// Any abstract undo actions
	view.attachEvent("onAction", (action, obj) => {
		if(!(obj.page && obj.page != view.getActiveSheet()))
			addToHistory(
				view,
				{
					action,
					row: obj.row || null,
					column: obj.column || null,
					value: webix.isUndefined(obj.value) ? null : obj.value,
					newValue: webix.isUndefined(obj.newValue) ? null : obj.newValue,
					extra: obj.extra || null,
					group: group.value
				}
			);
	});

	// column resize
	view.$$("cells").attachEvent("onColumnResize", (column, nvalue, ovalue) =>
		addToHistory(view, {action: "c-resize", row:0, column:column, value: ovalue, newValue: nvalue, group: group.value})
	);
	// column operations
	view.attachEvent("onColumnOperation", (action, start, end, page, extra) => {
		if(page == view.getActiveSheet() && action !== "add" && action !== "del")
			addToHistory(view, { action:{id: action, group:"column"}, group: group.value, column: {
				start: { column:start }, end: { column:end }
			}, extra: extra || null});
	});
	// row operations
	view.attachEvent("onRowOperation", (action, start, end, page, extra) => {
		if(page == view.getActiveSheet() && action !== "add" && action !== "del")
			addToHistory(view, { action: {id: action, group:"row"}, group: group.value, row: {
				start: {row: start}, end: {row: end}
			}, extra: extra || null});
	});
	// row resize
	view.$$("cells").attachEvent("onRowResize", (row,  nvalue, ovalue) =>
		addToHistory(view, {action: "r-resize", row: row, column:0, value: ovalue, newValue: nvalue, group: group.value})
	);

	// condition formats
	view.attachEvent("onBeforeConditionSet", (row, column, value, nvalue, page) => {
		if(isCellLocked(view, row, column, page)) return false;
		if(page == view.getActiveSheet()){
			value = value ? webix.copy(value) : null;
			addToHistory(view, {action: "condition", row, column, value, newValue: nvalue, group: group.value});
		}
	});

	// zoom
	view.attachEvent("onZoom", (value, oldVal, page) => {
		if(page == view.getActiveSheet())
			addToHistory(view, {action: "zoom", value: oldVal, newValue: value, group: group.value});
	});

	view.$skipHistory = 0;
}

export function undo(view){
	restoreHistory(view,-1);
}

export function redo(view){
	restoreHistory(view,1);
}

export function reset(view){
	if(!ignoreUndoReset){
		view._ssUndoHistory = [];
		view._ssUndoCursor = -1;
	}
}

function addToHistory(view, data){
	if(!view.$skipHistory && !view._loading_data){
		// remove futher history
		view._ssUndoHistory.splice(view._ssUndoCursor+1);
		// add to an array and increase cursor
		view._ssUndoHistory.push(data);
		view._ssUndoCursor++;
	}
}

export function ignoreUndo(func, view){
	view.$skipHistory++;
	try{
		func.call(view);
	}
	finally {
		view.$skipHistory--;
	}
}

export function ignoreReset(func){
	ignoreUndoReset = true;
	func();
	ignoreUndoReset = false;
}

function restoreHistory(view, step){
	var data = view._ssUndoHistory[step>0?(view._ssUndoCursor+step):view._ssUndoCursor];
	if(data){
		var value = step > 0 ? data.newValue : data.value;
		var direction = step>0;
		var params = [data.action, data.row, data.column, value, direction, data.extra];

		view._ssUndoCursor += step;

		// group support
		var group = data.group;
		var prevData = view._ssUndoHistory[step>0?(view._ssUndoCursor+step):view._ssUndoCursor];

		ignoreUndo(function(){
			view.callEvent("onUndo", params);
			if (!group || !(prevData && group == prevData.group)){
				view.refresh();
				view.callEvent("onAfterUndo", []);
			}
		},view);

		if(prevData && group && group == prevData.group){
			restoreHistory(view, step);
		}
	}
}

function undoHandlers(view){
	view.attachEvent("onUndo", function(type, row, column, value) {
		switch (type) {
			case "freeze-row":
				view.freezeRows(value);
				break;
			case "freeze-column":
				view.freezeColumns(value);
				break;
		}
	});
}